import React, { useEffect, useState } from "react";
import { Box } from "@mui/material";
import Header from "./Header";
import CollapsiblePanel from "./CollapsiblePanel";
import History from "./History";
import Parameters from "./Parameters";
import Splines from "./Splines";
import DataInput from "./DataInput";
import { getInitialState } from "./DefaultParameters";

/**
 * Calibration tab layout. Calls POST /api/v1/microslide/calibrate.
 */
export default function CalibrationLayout() {
    const [resultsCollapsed, setResultsCollapsed] = useState(true);
    const [dataCollapsed, setDataCollapsed] = useState(false);
    const [splinesCollapsed, setSplinesCollapsed] = useState(true);
    const [paramsCollapsed, setParamsCollapsed] = useState(true);

    // One row per calibration level; resp1/resp2 hold replicate values
    // (comma- or space-separated). Mirrors the old MSDualWavelengthLevel
    // { SAV, Resp1[], Resp2[] } shape.
    const [rows, setRows] = useState([{ sav: "", resp1: "", resp2: "" }]);
    const [parameters, setParameters] = useState(getInitialState());
    const [splines, setSplines] = useState({
        preprocessing: null, g1: null, g2: null, g3: null, g4: null
    });

    const [resultDataMap, setResultDataMap] = useState(() => {
        const saved = sessionStorage.getItem("microslideHistory_calibrate");
        return saved ? JSON.parse(saved) : {};
    });

    useEffect(() => {
        if (resultDataMap && Object.keys(resultDataMap).length > 0) {
            setResultsCollapsed(false);
        }
    }, [resultDataMap]);

    return (
        <div>
            <Header
                mode="calibrate"
                rows={rows}
                parameters={parameters}
                setParameters={setParameters}
                extras={{ splines }}
                setResultDataMap={setResultDataMap}
                onRun={() => setResultsCollapsed(false)}
            />

            <Box display="flex" flexDirection="column" padding={2}>
                <CollapsiblePanel
                    title="Results"
                    collapsed={resultsCollapsed}
                    onToggle={() => setResultsCollapsed(!resultsCollapsed)}
                >
                    <History
                        resultDataMap={resultDataMap}
                        resultFields={["A0", "A1", "A2", "A3", "Calibrated", "ConditionCode", "Error"]}
                    />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Calibration Data (one row per level)"
                    collapsed={dataCollapsed}
                    onToggle={() => setDataCollapsed(!dataCollapsed)}
                >
                    <DataInput
                        columns={[
                            { key: "sav", label: "SAV" },
                            { key: "resp1", label: "Response 1 reps" },
                            { key: "resp2", label: "Response 2 reps" }
                        ]}
                        rows={rows}
                        setRows={setRows}
                        placeholder={"SAV\tResp1 (comma sep)\tResp2 (comma sep)\n0\t0.10, 0.11\t0.05, 0.06\n10\t0.50, 0.52\t0.25, 0.26\n..."}
                    />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Splines"
                    collapsed={splinesCollapsed}
                    onToggle={() => setSplinesCollapsed(!splinesCollapsed)}
                >
                    <Splines splines={splines} setSplines={setSplines} />
                </CollapsiblePanel>

                <CollapsiblePanel
                    title="Assay Parameters"
                    collapsed={paramsCollapsed}
                    onToggle={() => setParamsCollapsed(!paramsCollapsed)}
                >
                    <Parameters parameters={parameters} setParameters={setParameters} />
                </CollapsiblePanel>
            </Box>
        </div>
    );
}
